import { Typography } from "@material-ui/core";
import { makeStyles } from '@material-ui/styles';
import Link from 'next/link';
import React from "react";

const useStyles = makeStyles(theme => ({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        paddingTop: 15,
		'& a': {
			textDecoration: 'none'
		},
        [theme.breakpoints.up('sm')]: {
            paddingTop: 0,
            borderTop: 'none'
        }
    },
    manufacturer: {
        marginBottom: 5,
        fontSize: 11.5,
        fontWeight: 300,
        color: "#000000",
        letterSpacing: 1,
        textTransform: 'uppercase'
    },
    name: {
        fontSize: 22,
        fontFamily: 'Chronicle, serif',
        fontWeight: 400,
        [theme.breakpoints.up('md')]: {
            fontSize: 32
        }
    }
}), { name: 'ProductInfo' });

export default function ProductInfo({ breadcrumbs, product }) {
    const classes = useStyles();

    function getManufacturer() {
        const manufacturer = product.manufacturer;

        return manufacturer?.translated?.name || false;
    }

    function getManufacturerLink() {
        const manufacturer = product.manufacturer;

        return manufacturer.link || false;
    }

    function getLastBreadcrumb() {
        let breadcrumbIds = breadcrumbs ? Object.keys(breadcrumbs) : [];

        return breadcrumbIds ? breadcrumbs[breadcrumbIds[breadcrumbIds.length - 1]].name : 'Newport';
    }

    function capitalizeProductName() {
        const words = product?.translated?.name.split(" ");
        return words.map((word) => {
            if (word === 'cm') {
                return word
            }

            if (word[0] && word?.substring(1)) {
                return word[0]?.toUpperCase() + word?.substring(1);
            }

            if (word[0] && word.length === 1) {
                return word[0];
            }

            return ''
        }).join(" ");

    }

    return (
        <div className={classes.wrapper}>
            {getManufacturer() ?
                (getManufacturerLink() ?
                    <Link href={getManufacturerLink()}><a><Typography variant="body1" className={classes.manufacturer}>{getManufacturer()}</Typography></a></Link> :
                    <Typography variant="body1" className={classes.manufacturer}>{getManufacturer()}</Typography>)
                : <Typography variant="body1" className={classes.manufacturer}>{getLastBreadcrumb()}</Typography>
            }
            <Typography variant="h1" className={classes.name}
                        dangerouslySetInnerHTML={{ __html: capitalizeProductName() }}/>
        </div>
    );
}
